import script from "./CalendarProfileComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarProfileComponent.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarProfileComponent.vue?vue&type=style&index=0&id=7a26f8e0&lang=css"

const __exports__ = script;

export default __exports__